<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:34:24
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-04 11:09:56
 * @Description: 
-->

<template>
    <component
        :is="forHistoryPage ? 'div' : TheModalTitle"
        container-class=""
        :model-value="modelValue"
        :backdrop="backdrop"
        @update:model-value="onModelValue"
    >
        <template #header
            v-if="!forHistoryPage"
        >
            <span class="text-[24px] leading-10">
                {{ `${$t('History')}` }}
            </span>
        </template>
        <!-- 
            ↑ 顶部标题
            ↓ 窗口内容主体 
        -->
        <div class="w-full">
            <ButtonRulesTopTab
                :tabList="oTabCenter.arr"
                v-model="oTabCenter.sActiveTab"
            ></ButtonRulesTopTab>
            <div class="my-1 text-[#93acd3]">{{$t('game.statisticsTitle')}}</div>
            <div class="figure-box">
                <div class="left-user">
                    <UserAvatar
                        class="shrink-0"  
                        size="42px"
                        self
                    />
                    <span class="text truncate">
                        {{ userStore.name }}
                    </span>
                </div>
                <div class="right-amount">
                    <CurrentCoin
                        class=""
                        size="24px"
                    />
                    <span class="text">
                        {{ getFixed(oActiveInfo.winAmountSum) }}
                    </span>
                </div>
            </div>
            <!-- 分界 -->
            <div class="analysis gray-box">
                <div v-for="(cur, idx) of aAnalsisActive"
                    :key="idx"
                >
                    <h6 class="title">
                        {{ $t(cur.i18nKey) }}
                    </h6>
                    <em class="quantity">
                        <img :src="cur.sIcon" />
                        <ClientOnly>
                            <!-- 下方值会在切换页面时自动变换 -->
                            {{ cur.theVal }}
                        </ClientOnly>
                    </em>
                </div>
            </div>
            <!--
                ↑ 统计栏
                ↓ 大表格：依次为“抢”红包表格，“发” 红包表格 
            -->
            <div class="big-list gray-box">
                <section v-if="isActiveCollecting">
                    <q-table
                        key="collecting"
                        v-bind="oTableSetting"
                        row-key="name"
                        :no-data-label="$t('Noinformation')"
                        :rows="oTableData[oTabs.collecting].tableArr"
                        :columns="oTableData[oTabs.collecting].aColumns" 
                        table-class=""
                        :class="{
                            [forHistoryPage ? '' : 'h-[300px]']: true, 
                        }"
                    >
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td class="td-time" key="date">
                                    <div class="td-inner">
                                        <span class="text">
                                            {{ fnGetTime(props.row.date * 1000)[0] }}<br/> 
                                            {{ fnGetTime(props.row.date * 1000)[1] }}
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="td-user" key="sendUser">
                                    <div class="td-inner ">
                                        <UserAvatar
                                            class="shrink-0"  
                                            size="18px"
                                            :src="props.row.sendUser.avatar"
                                        />
                                        <span class="text truncate">
                                            {{ props.row.sendUser.name }}
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="" key="name">
                                    <img v-if="props.row.winAmount < 0"
                                        class="w-[18px] max-w-none"
                                        src="@/pages/casino/redpacketGame/img/small_bomb.png" 
                                    />
                                </q-td>
                                <q-td class="td-amount" key="name">
                                    <div class="td-inner ">
                                        <CurrentCoin
                                            size="18px"
                                            class=""
                                            :name="props.row.currency"
                                        />
                                        <span class="flex flex-col"> 
                                            <span class="text "
                                                :class="{won: props.row.shareAmount > 0}"
                                            >
                                                {{ getFixed(props.row.shareAmount) }}
                                            </span>
                                            <span class="text loose mt-[2px] ml-[-2px]"
                                                v-if="props.row.mineAmount || props.row.is_mine" 
                                            >
                                                -{{ getFixed(props.row.mineAmount) }}
                                            </span>
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="td-btn" key="amountInUsd">
                                    <button class="see-deail"
                                        @click.prevent="fnSeeDetail(props.row)"
                                    >
                                        <IconSvgUse use="icon-info-circle-2"
                                            size="16px" 
                                        /> 
                                    </button>
                                </q-td>
                            </q-tr>
                        </template>
                        <template v-slot:no-data="{ message }">
                            <div class="loading-box"
                                v-if="oTableData[oTabs.collecting].isLoading"
                            >
                                <IconSvgUse use="icon-loading"
                                    size="30px" 
                                    class="animate-spin"
                                /> 
                            </div>
                            <div class="no-data-message"
                                v-else
                            >
                                <img class="no-data-pic"
                                    src="@/assets/imgs/no-data.webp"
                                />
                                <p class="no-data-tips">
                                    {{ message }}
                                </p>
                            </div>
                        </template>
                    </q-table>
                    <div class="history-pagination"
                        v-if="forHistoryPage"
                    >
                        <q-pagination
                            v-model="oTableData[oTabs.collecting].pageConfig.page"
                            :max="Math.ceil(
                                oTableData[oTabs.collecting].total 
                                / oTableData[oTabs.collecting].pageConfig.page_size 
                            )" 
                            :max-pages="4"
                            boundary-numbers
                            color="[#55657e]"
                            active-color="[#2281f6]"
                            direction-links
                            @update:model-value="(iPageNo) => fnTableDataLoader(iPageNo)"
                        />
                    </div>
                </section>
                <!-- ↑【抢】红包记录 -->
                <!-- ↓【发】红包记录 -->
                <section v-else>
                    <q-table
                        key="sending"
                        v-bind="oTableSetting"
                        row-key="name"
                        :no-data-label="$t('Noinformation')"
                        :rows="oTableData[oTabs.sending].tableArr"
                        :columns="oTableData[oTabs.sending].aColumns" 
                        :class="{
                            [forHistoryPage ? '' : 'h-[300px]']: true, 
                        }"
                        table-class=""
                    >
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td class="td-time" key="date">
                                    <div class="td-inner">
                                        <span class="text">
                                            {{ fnGetTime(props.row.date * 1000)[0] }}<br/> 
                                            {{ fnGetTime(props.row.date * 1000)[1] }}
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="td-detail" key="name">
                                    <div class="td-inner ">
                                        <img class="small-pack-icon w-[18px]"
                                            :src="smallPack"
                                        />
                                        <span class="text">
                                            {{ `${props.row.allNum - props.row.leftNum}/${props.row.allNum}` }}
                                            <em>
                                                {{ getFixed(props.row.base) }}
                                            </em>
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="td-amount" key="name">
                                    <div class="td-inner ">
                                        <span class="text truncate"
                                            :class="{won: props.row.winAmount > 0}"
                                        >
                                            {{ getFixed(props.row.winAmount) }}
                                        </span>
                                    </div>
                                </q-td>
                                <q-td class="td-btn" key="amountInUsd">
                                    <!-- ↓ Popper 在 ClientOnly 之内，可免于报错 -->
                                    <template v-if="props.row.allNum == props.row.leftNum">
                                        <ClientOnly>
                                            <Popper
                                                :key="props.rowIndex" 
                                                hover
                                                arrow
                                                placement="top"
                                                :style="oPopperStyle"
                                            >
                                                <button class="see-deail" disabled>
                                                    <IconSvgUse use="icon-info-circle-2" size="16px"/> 
                                                </button>
                                                <template #content>
                                                    <p class=" text-[#93acd3]">
                                                        {{ $t('redPacketMines.noDetail') }}
                                                    </p>
                                                </template>
                                            </Popper>
                                        </ClientOnly>
                                    </template>
                                    <button v-else
                                        class="see-deail"
                                        @click.prevent="fnSeeDetail(props.row)"
                                    >
                                        <IconSvgUse use="icon-info-circle-2" size="16px"/> 
                                    </button>
                                </q-td>
                            </q-tr>
                        </template>
                        <template v-slot:no-data="{ message }">
                            <div class="loading-box"
                                v-if="oTableData[oTabs.sending].isLoading"
                            >
                                <IconSvgUse use="icon-loading"
                                    size="30px" 
                                    class="animate-spin"
                                /> 
                            </div>
                            <div class="no-data-message"
                                v-else
                            >
                                <img class="no-data-pic"
                                    src="@/assets/imgs/no-data.webp"
                                />
                                <p class="no-data-tips">
                                    {{ message }}
                                </p>
                            </div>
                        </template>
                    </q-table>
                    <div class="history-pagination"
                        v-if="forHistoryPage"
                    >
                        <q-pagination
                            v-model="oTableData[oTabs.sending].pageConfig.page"
                            :max="Math.ceil(
                                oTableData[oTabs.sending].total 
                                / oTableData[oTabs.sending].pageConfig.page_size 
                            )" 
                            :max-pages="4"
                            boundary-numbers
                            color="[#55657e]"
                            active-color="[#2281f6]"
                            direction-links
                            @update:model-value="(iPageNo) => fnTableDataLoader(iPageNo)"
                        />
                    </div>
                </section>
            </div>
            <!-- ↓ 最后的提示文字 -->
            <p class="bottom-tips"
                v-if="!forHistoryPage"
            >
                {{
                    $t(
                        'redPacketMines.AsMuch20Records',
                        {
                            rows: oRowOriginalConfig.page_size, 
                        },
                    )
                }}
            </p>
        </div>
    </component>
    <!-- 
        ↓ 以下是窗口 
    -->
    <ClientOnly>
        <!-- ↓ 浮层页专用，另外在游戏内部时是通过修改 route 参数触发弹出游戏详情，不依赖此处的组件 --> 
        <RedPacketHistoryDetail
            v-if="forHistoryPage"
            :gameDropValue="'redpacket'"
            :historyDetail="oHistoryQuery"
        />
    </ClientOnly>
</template>

<script lang="ts" setup>
import moment from 'moment';
import Popper from "vue3-popper";
import RedPacketHistoryDetail from '@/components/Casino/History/Modal/GameDetali/index.vue'; 
import TheModalTitle from '@/components/Modal/Title.vue'; 
import { useRatesStore } from '~/stores/cansino/rates';

import { useUserStore } from '@/stores/user';
import useGlobalStore from '@/stores/global';
import smallBomb from '@/pages/casino/redpacketGame/img/small_bomb.png';
import smallPack from '@/pages/casino/redpacketGame/img/small_pack.png'; 
import {useRedPacket} from '@/socket/game/redpacket'; 
import {
    ActionInt,
    type RunningType,
} from '@/pages/casino/redpacketGame/ts/redPacketCommon';


const props = defineProps({
    modelValue: Boolean, // 
    forHistoryPage: {
        type: Boolean,
        default: false, 
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
});

const {
    EMIT_GET_REDPACKET_HISTORY, // 查询游戏历史信息列表
} = useRedPacket();
const oHistoryQuery = ref({});

const oRowOriginalConfig = {
    page: 1,
    page_size: 50, // 固定 50 
};

const rates = useRatesStore();
const userStore = useUserStore();
const oGlobalStore = useGlobalStore();
const {t: $tFn, locale} = useNuxtApp().$i18n;
const emit = defineEmits(['update:modelValue']);
const oTableSetting = {
    pagination: {
        rowsPerPage: 50, // 接口最多返回 50 行 
    },
    'hide-pagination': !!1,
    'class': 'big-table', 
}; 

// -- ↑ 导入外部资源，声明常量等 ------
// -- ↓ 内部值 -----------------------  

const oTabs:{
    [K in RunningType]: string; 
} = Object.freeze({
    collecting: 'redPacketMines.RecordsGrabbed',  // 他们也是 i18nKey 
    sending: 'redPacketMines.SentRecords',
});

const oTabCenter = reactive({
    // ↓ 这是顶部页签 
    arr: [{
        label: oTabs.collecting, // i18nKey 
    }, {
        label: oTabs.sending,
    }],
    sActiveTab: oTabs.collecting,
});

// ↓ 得出当前是否是“抢” 红包记录页 
const isActiveCollecting = computed(()=>{
    return (
        oTabs.collecting
        ===
        oTabCenter.sActiveTab
    );
});


// ↓ 当前页的相关信息，
const oActiveInfo = computed(() => {
    // 默认为“抢包” 页 
    const oResult = {
        iAction: ActionInt.collecting,
        tableArr: oTableData[oTabs.collecting].tableArr,
        winAmountSum: 0, // 下方赋值 
    };
    if (isActiveCollecting.value == false){
        Object.assign(oResult, {
            iAction: ActionInt.sending, 
            tableArr: oTableData[oTabs.sending].tableArr,
        });
    }
    
    const sNowCurrency = userStore.currentCurrency; 
    const oRates = rates.comparisonCurrencyList; 
    oResult.winAmountSum = oResult.tableArr.reduce((fResult, oCur)=>{
        const sRule = oCur.currency + sNowCurrency; 
        let fRate = (
            oCur.currency === sNowCurrency
            ? 1
            : oRates[sRule]
        );
        // console.log(sRule, fRate);
        return fResult + (oCur.winAmount * fRate); 
    }, 0);
    return oResult;
});



// 两类统计内容 
const oAnalsisBoth = computed(()=>{
    const collectingTable = oTableData[oTabs.collecting].tableArr;
    const sendingTable = oTableData[oTabs.sending].tableArr;
    const oResult = {
        [oTabs.collecting]: [{
            sIcon: smallPack,
            i18nKey: 'redPacketMines.HongbaoGot',
            theVal: collectingTable.length,
        }, {
            sIcon: smallBomb,
            i18nKey: 'redPacketMines.BombQty',
            theVal: collectingTable.filter(cur => cur.winAmount <= 0).length,
        }],
        [oTabs.sending]: [{
            sIcon: smallPack,
            i18nKey: 'redPacketMines.HongbaoSent',
            theVal: sendingTable.length,
        }, {
            sIcon: smallBomb,
            i18nKey: 'redPacketMines.BombQty',
            theVal: sendingTable.filter(cur => cur.winAmount > 0).length, 
        }],
    };
    return oResult; 
});

// 两类表格
const oTableData = reactive({
    [oTabs.collecting]: {
        aColumns: [{
            label: $tFn('Time'),
            name: '',
            field: '',
        },{
            label: $tFn('redPacketMines.sender'),
            name: '', // 添加 name, field 消除 ts 报错 
            field: '',
        },{
            label: '',
            name: '',
            field: '',
        },{
            label: $tFn('redPacketMines.AmountReceived'),
            name: '',
            field: '',
        },{
            label: '',
            name: '',
            field: '',
        },],
        tableArr: [], 
        total: 0, 
        isLoading: true,
        pageConfig: deepCopy(oRowOriginalConfig),
    },
    [oTabs.sending]: {
        aColumns: [{
            label: $tFn('Time'),
            name: '',
            field: '',
        },{
            label: $tFn('redPacketMines.historyDetails'),
            name: '',
            field: '',
        },{
            label: $tFn('redPacketMines.Profit'),
            name: '',
            field: '',
        },{
            label: '',
            name: '',
            field: '',
        },],
        tableArr: [], 
        total: 0, 
        isLoading: true,
        pageConfig: deepCopy(oRowOriginalConfig),
    },
});

// ↓ 当前统计数据 
const aAnalsisActive = computed(()=>{
    const key = oTabCenter.sActiveTab;
    return oAnalsisBoth.value[key];
});


/* 
    ↑ 各式数据
    ================================================== 
    ↓ 各式函数，方法等 
*/

/**
 * 加载当前页的数据 
 */
const fnTableDataLoader = async (
    iPageNo = null,
) => {
    // console.log('iPageNo', iPageNo); // 调试
    // ↓ 在顶部提前声明出来 
    const oTarget = oTableData[oTabCenter.sActiveTab];
    Object.assign(oTarget, {
        // total: 0, // 不能改，否则页码会强制退到 1 
        // tableArr: [], // 是否清空，观察中 
        isLoading: true, 
    });
    // if (1 && import.meta.dev){
    //     await Sleep(2000);
    // }
    const res = await EMIT_GET_REDPACKET_HISTORY({
        action: oActiveInfo.value.iAction, 
        page: oTarget.pageConfig.page,
        page_size: oTarget.pageConfig.page_size,
    }).finally(()=>{
        oTarget.isLoading = false; 
    });
    if (!res || res['error']){
        showNegativeNotify(res?.['error']);
        return;
    }
    Object.assign(oTarget, {
        total: res['total'] || 0,
        tableArr: res['all'] || [],
    });
    // console.log('history ↓\n', deepCopy(oTarget));
};

const fnGetTime = (
    ts:number, 
)=>{
    // const ts = Date.now(); 
    const sFormst = (
        locale.value === 'cn'
        ? 'YYYY/MM/DD HH:mm:ss'
        : 'MM/DD/YYYY hh:mm:ss A'
    );
    const sTime = moment(ts).format(sFormst);
    const aTime = sTime.split(' ');
    return [
        aTime[0],
        aTime.slice(1).join(' '),
    ];
}

/**
 * 查看历史的详情
 */
const fnSeeDetail = (oTarget)=>{
    console.log('红包游戏查看历史详情，打开窗口',oTarget);  
    const query = {
        modal: 'BetDetails',
        data: `redpacket:${oTarget.groupId}`, 
        playerId: userStore.id,
    };
    if (props.forHistoryPage){
        oHistoryQuery.value = query;
        return;
    }
    const router = useRouter();
    const route = useRoute();
    router.push({
        replace: true,
        path: route.path,
        query,
    });
}


// ↓监听窗口自身的打开 
watch(()=>props.modelValue, async (isShowing)=>{
    if (
        import.meta.server
        || !isShowing
        || props.forHistoryPage 
    ) {
        return;
    }
    fnTableDataLoader(); 
}, {
    immediate: true, 
});

// ↓ 页签切换后需要加载数据 
watch(
    () => oTabCenter.sActiveTab,
    (sNewTab)=>{
        const oCurrent = oTableData[sNewTab];
        if (!oCurrent.tableArr.length){
            fnTableDataLoader(); 
        }
    },
);

/**
 * 控制自身的开/关 
 */
const onModelValue = (value) => {
    // console.log('收到新值：', value); 
    emit('update:modelValue', !!value); 
};

onMounted(()=>{
    if (props.forHistoryPage){
        fnTableDataLoader(); 
    }
});
</script>


<style lang="scss" scoped>
.figure-box{
    display: flex; 
    align-items: center; 
    justify-content: space-between; 
    margin: 15px 0 15px;
    .left-user,
    .right-amount{
        display: flex; 
        align-items: center; 
        &>*:nth-child(1){
            margin-right: 8px; 
        }
    }
    .left-user{
        margin: 0 20px 0 0; 
        overflow: hidden; 
        .text{
            font-weight: 600;
            font-size: 14px;
            color: rgba(167, 181, 202, 1); 
        }
    }
    .right-amount{
        .text{
            font-weight: 700;
            font-size: 24px;
            text-align: right;
            color: white; 
        }        
    }
}

.gray-box{
    background: rgba(32, 42, 57, 1);
    padding: 12px;
    border-radius: 8px; 
}

.analysis{
    margin: 10px 0;
    padding: 12px 15px; 
    display: flex;
    justify-content: space-between;
    align-items: center; 
    &>*{
        flex: 1 1 50%; 
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .title{
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: rgba(147, 172, 211, 1);
        margin: 0 0 12px; 
    }
    .quantity{
        color: white; 
        font-weight: 800;
        font-size: 20px;
        display: flex;
        align-items: center; 
        img{
            width: 22px; 
            margin: 0 6px 0 -3px; 
        }
    }
}

.big-list{
    // .big-table{
    //     height: 300px; 
    // }
    & :deep(.q-table__card){
        background-color: transparent; 
        box-shadow: none; 
    }
    & :deep(table.q-table){
        width: 100%;
        overflow: hidden;
        background-color: transparent; 
        tr{
            // border-bottom: 0.5px solid var(--bet-corgi-color-white-12, rgba(255, 255, 255, 0.12))
            border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        }
        tbody tr:hover{
            background-color: rgb(0,0,0, 0.1);
        }
        th{
            color: rgba(85, 101, 126, 1);
            font-size: 12px; 
            text-align: left;
            padding: 0 3px; 
        }
        td{
            opacity: 1; 
            padding: 0 3px; 
        }
    }
    td .td-inner{
        font-size: 14px;
        line-height: 14px;
        vertical-align: middle;
        display: flex;
        align-items: center; 
        overflow: hidden; 
        max-width: 99%;
        // padding: 8px 0; 
        min-height: 48px; 
        .user-avatar,
        img{
            margin: 0 5px 0 0;
        }
        .text{
            min-width: 10px; 
        }
    }
    .td-user{
        color: white;
        font-weight: 600;
        font-size: 14px;
    }
    .td-amount{
        color: rgba(167, 181, 202, 1);
        min-width: 65px; 
        font-weight: 700;
        img{
            display: inline-block;  
        }
        .won{
            color: rgba(27, 184, 61, 1);
        }
        .loose{
            color: rgba(237, 29, 73, 1); 
        } 
    }
    .td-time{
        .text{
            color: rgba(167, 181, 202, 1);
            font-weight: 600;
            font-size: 12px;
        }
    }
    .td-detail{
        color: white;
        font-weight: 700;
        min-width: 70px;
        // .small-pack-icon{
        //     display: none; 
        // }
        em{
            color: rgba(27, 184, 61, 1);
        }
    }
    .td-btn{
        button.see-deail{
            // margin: 0 10px 0 auto; 
            background: rgba(68, 88, 116, 0.24);
            color: rgba(151, 151, 151, 1); 
            width: 20px;
            height: 20px;
            border-radius: 5px;
            display: flex;
            justify-content: center; 
            align-items: center; 
            &:hover,
            &:active{
                opacity: 0.9; 
            }
            .q-icon{
                margin: 0;
                display: inline-block;
                opacity: 0.7;
            }
        }
    }
}

.history-pagination{
    width: 100%; 
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    margin-top: 20px;
    :deep(.q-pagination) {
        button {
            background: #545c6c40;
            color: #55657e;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 600;
            height: 35px;
            min-width: 35px !important;
            margin: 0 2px;
        }
        .q-btn--standard {
            background: #2281f6;
            font-size: 15px;
        }
    }
}

@media screen and (min-width: 361px){
    .small-pack-icon{
        display: inline-block !important; 
    }
}

.bottom-tips{
    text-align: center;
    color: rgba(167, 181, 202, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    vertical-align: middle;
    padding: 0.8em 0 0; 
}

.loading-box{
    min-height: 150px; 
    width: 100%; 
    display: flex; 
    justify-content: center;
    padding: 45px 0 0; 
}

.no-data-message{
    min-height: 150px; 
    width: 100%; 
    padding: 20px;
    text-align: center; 
    .no-data-pic{
        width: 165px;
        margin: 0 auto 0; 
    }
    .no-data-tips{
        font-size: 14px; 
        color: rgba(167, 181, 202, 1); 
    }
}

</style>


